module.exports = __webpack_public_path__ + "static/Bullywug-61fe1746541be7dfd47b7478f6a32ed6.jpg";